<template>
  <div class="stack">
    <div class="stack__list">
      <AvatarBorder
        class="stack__item"
        :src="`${DROPS_ICON}`" 
        :size="36"
        :borderSize="2" 
        :borderColor="'var(--bg-primary)'"
        v-if="!isTelegram && isModerator"
      />
      <AvatarBorder
        v-for="image in avatarList"
        :key="image"
        class="stack__item"
        :src="`${image}`" 
        :size="36"
        :borderSize="2" 
        :borderColor="'var(--bg-primary)'"
      />
    </div>
    <span class="stack__counter">
      <ActiveBellIcon /> {{ displayCount }}
    </span>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useUserAuth } from '@/Groups/Notifications/private/imports/userStoreData';
  import { useNotificationsState } from '@/Groups/Notifications/private/composables/computedValues';
  //-------------------------------------
  import ActiveBellIcon from '@/Groups/Notifications/private/svg/ActiveBellIcon.vue';
  import { AvatarBorder } from '@/Groups/Notifications/private/imports/externalTemplates';
  //-------------------------------------
  const { avatarList, notificationsCount } = useNotificationsState();
  //-------------------------------------
  const { isTelegram, isModerator } = useUserAuth();
  //-------------------------------------
  const DROPS_ICON = require('@/Groups/Notifications/private/media/drops.png');
  //-------------------------------------
  const displayCount = computed(() => {
    const base = Number(notificationsCount.value || 0);
    return !isTelegram.value && isModerator.value ? base + 1 : base;
  });
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>